export function getLoginRedirect(from, fallback) {
    if (typeof from !== 'string' || !from.startsWith('/') || from.startsWith('//') || /[\\\s]/.test(from)) {
        return fallback;
    }

    const pathname = new URL(from, 'https://internal.invalid').pathname.replace(/\/+$/, '').toLowerCase();
    if (pathname === '/login' || pathname === '/manager/login') {
        return fallback;
    }

    return from;
}
